import React, { useState, useEffect } from 'react';
import { array, arrayOf, bool, func, shape, string, oneOf, object } from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import PDFSVG from '../../assets/pdf.svg';
import { ReactComponent as LocationIcon } from '../../components/OrderPanel/LocationIcon.svg'
import { ReactComponent as MailIcon } from '../../components/OrderPanel/MailIcon.svg'
import { ReactComponent as PhoneIcon } from '../../components/OrderPanel/PhoneIcon.svg'
import { ReactComponent as WhatsAppIcon } from '../../components/OrderPanel/WhatsAppIcon.svg'

import { useDispatch, useSelector } from 'react-redux';
import { getAuthorWarehouses } from '../ManageWarehousePage/ManageWarehousePage.duck.js';
import { createResourceLocatorString, pathByRouteName } from '../../util/routes';
import { listingPageLinkProps } from '../../util/listingSeoUrl';
import { brandLabel } from '../../util/brandLabel';
import { trackViewContent, toMajorUnits } from '../../util/metaPixel';
import { trackViewItem, buildItemFromListing, trackListingEvent } from '../../util/ecommerceEvents';
import { updateFavourites } from '../../containers/SearchPage/SearchPage.duck';
import { updateTotalLikes } from '../../util/api.js';


// Contexts
import { useConfiguration } from '../../context/configurationContext';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';
// Utils
import { FormattedMessage, intlShape, useIntl } from '../../util/reactIntl';
import { LISTING_STATE_PENDING_APPROVAL, LISTING_STATE_CLOSED, propTypes } from '../../util/types';
import { types as sdkTypes } from '../../util/sdkLoader';
import {
  LISTING_PAGE_DRAFT_VARIANT,
  LISTING_PAGE_PENDING_APPROVAL_VARIANT,
  LISTING_PAGE_PARAM_TYPE_DRAFT,
  LISTING_PAGE_PARAM_TYPE_EDIT,
  createSlug,
} from '../../util/urlHelpers';
import { convertMoneyToNumber, customFormatMoney } from '../../util/currency';
import {
  SALES_UNIT_SET,
  getUnitNoun,
  resolveSalesUnit,
  stockAvailability,
} from '../../util/salesUnit';
import { findCategoryById, isUsableFacetValue } from '../../util/listingFacets';
import { fitFactRows } from '../../util/answerContentCore';
import { isBusinessProfile } from '../../util/profileSeoUrl';
import {
  ensureListing,
  ensureOwnListing,
  ensureUser,
  userDisplayNameAsString,
} from '../../util/data';
import { richText } from '../../util/richText';
import {
  isBookingProcess,
  isPurchaseProcess,
  resolveLatestProcessName,
} from '../../transactions/transaction';

// Global ducks (for Redux actions and thunks)
import { getMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { manageDisableScrolling, isScrollingDisabled } from '../../ducks/ui.duck';
import { initializeCardPaymentData } from '../../ducks/stripe.duck.js';

// Shared components
import {
  Breadcrumbs,
  H4,
  H1,
  Page,
  NamedLink,
  NamedRedirect,
  OrderPanel,
  LayoutSingleColumn,
  ListingPageTab,
  SecondaryButton,
  Button,
  SocialShareMenu,
} from '../../components';

import { payListingBoostedPayment } from '../ManageListingsPage/ManageListingsPage.duck.js';


// Related components and modules
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';
import NotFoundPage from '../NotFoundPage/NotFoundPage';

import {
  sendInquiry,
  setInitialValues,
  fetchTimeSlots,
  fetchTransactionLineItems,
  getUserSavedQueries,
  updateListingViews,
  fetchAuthorPaymentStatus,
} from './ListingPage.duck';

import {
  LoadingPage,
  ErrorPage,
  priceData,
  listingImages,
  listingProductImages,
  handleContactUser,
  handleSubmitInquiry,
  handleSubmit,
} from './ListingPage.shared';
import ActionBarMaybe from './ActionBarMaybe';
import SectionTextMaybe from './SectionTextMaybe';
// P25009-498 — hidden for now, kept for later (see the render below).
// import SectionAnswerLeadMaybe from './SectionAnswerLeadMaybe';
import SectionPackageVariantsMaybe from './SectionPackageVariantsMaybe';
import SectionFullRangeCtaMaybe from './SectionFullRangeCtaMaybe';
// import SectionFitsAlsoMaybe from './SectionFitsAlsoMaybe';
import SectionReviews from './SectionReviews';
import WheelplaceInfoPanel from './WheelplaceInfoPanel/WheelplaceInfoPanel';
import MobileStickyCTA from './MobileStickyCTA/MobileStickyCTA';
import useBuyBoxOrder from './useBuyBoxOrder';
import SectionDescriptionClamp from './SectionDescriptionClamp';
import { plateInfoModelName } from '../../util/wheelFitment';
import { pickupPlaceFor, pickupPlaceLine } from '../../util/pickupPlace';
import { cleanListingTitle } from '../../util/listingTitle';
import { boltCircleText } from '../../util/boltCircleCore';
import GoogleReviewsBadge from '../ProfilePage/GoogleReviewsBadge';
import { MONTERING_TEMPLATE_KEY, servicesForListing } from '../../util/serviceTargetingCore';
import SectionAuthorMaybe from './SectionAuthorMaybe';
import SectionGallery from './SectionGallery';
import AiTryOn from '../../components/AiTryOn/AiTryOn';
import ViewWheelsOnCar from './ViewWheelsOnCar';
import CustomListingFields from './CustomListingFields';
import MobileSection from './MobileSection';
import { buildSpecLine } from '../ManageListingsPage/listingRowData';
import CompareSection from './CompareSection/CompareSection.js';
import SectionRecommendedListings from './SectionRecommendedListings/SectionRecommendedListings';

import css from './ListingPage.module.css';
import SectionCategoryMaybe from './SectionCategoryMaybe.js';
import { useRef } from 'react';
import { listingTown } from '../../util/listingTown';

const MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE = 16;

const { UUID } = sdkTypes;

export const ListingPageComponent = props => {
  const [inquiryModalOpen, setInquiryModalOpen] = useState(
    props.inquiryModalOpenForListingId === props.params.id
  );
  // const [showAuthorInfo, setShowAuthorInfo] = useState(false);

  const {
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    intl,
    onManageDisableScrolling,
    params: rawParams,
    location,
    scrollingDisabled,
    showListingError,
    reviews,
    fetchReviewsError,
    sendInquiryInProgress,
    sendInquiryError,
    monthlyTimeSlots,
    onFetchTimeSlots,
    onFetchTransactionLineItems,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    history,
    callSetInitialValues,
    onSendInquiry,
    onInitializeCardPaymentData,
    config,
    routeConfiguration,
    savedQueries,
    sessionURL,
    payListingBoostedPaymentSessionURL,
    onPayListingBoostedPayment,
  } = props;

  const urlParams = new URLSearchParams(location.search);
  const sessionId = urlParams.get("sessionId");

  const listingConfig = config.listing;
  console.log("listingConfig", listingConfig);
  const listingId = new UUID(rawParams.id);
  const isPendingApprovalVariant = rawParams.variant === LISTING_PAGE_PENDING_APPROVAL_VARIANT;
  const isDraftVariant = rawParams.variant === LISTING_PAGE_DRAFT_VARIANT;
  const currentListing =
    isPendingApprovalVariant || isDraftVariant
      ? ensureOwnListing(getOwnListing(listingId))
      : ensureListing(getListing(listingId));

  const authorId = currentListing?.author?.id?.uuid
  const dispatch = useDispatch();
  const { listingWarehouses } = useSelector(
    (state) => state.ManageWareHousePage
  );
  useEffect(() => {
    dispatch(getAuthorWarehouses(authorId));
    dispatch(getUserSavedQueries())
  }, []);

  /* P25009-452 BR-1 — an ad must not promise "Köp nu" for a seller the
   * checkout would refuse. The author's Stripe state is not readable from the
   * browser, so ask our server once per author (it answers with the same
   * predicate the initiate endpoints enforce). Runs client-side only; until
   * the answer arrives — or if it never does — the page fails open and keeps
   * the buy button. */
  const authorCanTakePayment = useSelector(
    state => state.ListingPage.authorCanTakePayment
  );
  const authorUsesOwnPayment = useSelector(
    state => state.ListingPage.authorUsesOwnPayment
  );
  useEffect(() => {
    if (authorId) {
      dispatch(fetchAuthorPaymentStatus(authorId));
    }
  }, [authorId]);

  const viewedListingId = useRef(null);

  useEffect(() => {
    const id = currentListing?.id?.uuid;
    if (!id) return;

    if (viewedListingId?.current !== id) {
      dispatch(updateListingViews(currentListing));
      // Tell Meta which product was viewed. content_ids is the listing UUID,
      // the same id the catalogue feed publishes, which is what lets Meta
      // retarget this exact product. Guarded by the same ref, so a re-render
      // does not report the view twice.
      const price = currentListing?.attributes?.price;
      trackViewContent({
        listingId: id,
        title: currentListing?.attributes?.title,
        value: toMajorUnits(price?.amount),
        currency: price?.currency,
      });
      // Same view, reported to Google Analytics 4. item_id is again the listing
      // UUID, matching the Merchant feed, so Shopping campaigns can join the
      // view to the product they advertised.
      trackViewItem({
        items: [buildItemFromListing(currentListing)],
        value: toMajorUnits(price?.amount),
        currency: price?.currency,
      });
      viewedListingId.current = id;
    }
  }, [currentListing?.id?.uuid]);

  const [showEmail, setShowEmail] = useState(false);
  const [showPhone, setShowPhone] = useState(false);
  const [showWhatsapp, setShowWhatsapp] = useState(false);

  const { SearchPage: searchPageReducer } = useSelector(state => state);
  const { updateFavouritesInProgress } = searchPageReducer || {};

  const [liked, setLiked] = useState(false);
  const userFavouriteListings =
    (currentUser && currentUser.attributes.profile.publicData.favoriteListings) || [];

  useEffect(() => {
    if (isLiked()) {
      setLiked(true);
    }
  }, [userFavouriteListings]);

  const isLiked = () => {
    const likedListings = userFavouriteListings;
    return likedListings && likedListings.includes(currentListing?.id?.uuid);
  };

  const toggleFavourite = event => {
    event.preventDefault();
    event.stopPropagation();

    if (!currentUser) {
      const state = { from: `${location.pathname}${location.search}${location.hash}` };
      history.push(createResourceLocatorString('SignupPage', routeConfiguration, {}, {}), state);
    } else {
      if (updateFavouritesInProgress) return;
      setLiked(!liked);

      const likedListings = userFavouriteListings;
      const listingId = currentListing.id.uuid;
      const currentlyLiked = likedListings.includes(listingId);
      const action = currentlyLiked ? "unlike" : "like";
      let newListings = likedListings ? likedListings : [];
      if (isLiked()) {
        newListings = likedListings.filter(l => l !== currentListing?.id?.uuid);
      } else {
        newListings.push(currentListing?.id?.uuid);
      }
      dispatch(updateFavourites(newListings))
        .then(() => {
          return updateTotalLikes({
            listingId,
            action,
          });
        })
        .catch(e => {
          console.error("Failed updating favourites or like count", e);
        });
    }
  };

  /* P25009-482 BR-2/BR-5/BR-6 — the order the buy box builds: quantity,
   * delivery choice and the total. Owned here, above the early returns (it is
   * a hook), because the buy box and the phone sticky bar both show it and
   * must never disagree. Server pricing is only asked for when the listing can
   * actually be bought by this visitor. */
  const orderProcessName = resolveLatestProcessName(
    (currentListing?.attributes?.publicData?.transactionProcessAlias || '').split('/')[0]
  );
  const orderIsOwnListing = !!(
    currentUser?.id &&
    currentListing?.author?.id &&
    currentListing.author.id.uuid === currentUser.id.uuid
  );
  const buyBoxOrder = useBuyBoxOrder({
    listing: currentListing,
    canOrder:
      isPurchaseProcess(orderProcessName) &&
      !orderIsOwnListing &&
      currentListing?.attributes?.state !== LISTING_STATE_CLOSED,
    isOwnListing: orderIsOwnListing,
  });
  const buyerCarPlate = useSelector(state => state.currentLicensePlate?.currentLicensePlate);

  const listingSlug = rawParams.slug || createSlug(currentListing.attributes.title || '');
  const params = { slug: listingSlug, ...rawParams };

  // Route + params of this listing's public URL. Normally the breadcrumb URL
  // (/l/:category/:make/:model/:slug/:id); the legacy /l/:slug/:id path for
  // listings that have no car make and model to put in it.
  const publicListingLink = listingPageLinkProps(currentListing, rawParams);

  const listingPathParamType = isDraftVariant
    ? LISTING_PAGE_PARAM_TYPE_DRAFT
    : LISTING_PAGE_PARAM_TYPE_EDIT;
  const listingTab = isDraftVariant ? 'photos' : 'details';

  const isApproved =
    currentListing.id && currentListing.attributes.state !== LISTING_STATE_PENDING_APPROVAL;

  const pendingIsApproved = isPendingApprovalVariant && isApproved;

  // If a /pending-approval URL is shared, the UI requires
  // authentication and attempts to fetch the listing from own
  // listings. This will fail with 403 Forbidden if the author is
  // another user. We use this information to try to fetch the
  // public listing.
  const pendingOtherUsersListing =
    (isPendingApprovalVariant || isDraftVariant) &&
    showListingError &&
    showListingError.status === 403;
  const shouldShowPublicListingPage = pendingIsApproved || pendingOtherUsersListing;

  if (shouldShowPublicListingPage) {
    return <NamedRedirect {...publicListingLink} search={location.search} />;
  }

  const topbar = <TopbarContainer />;

  if (showListingError && showListingError.status === 404) {
    // 404 listing not found
    return <NotFoundPage staticContext={props.staticContext} />;
  } else if (showListingError) {
    // Other error in fetching listing
    return <ErrorPage topbar={topbar} scrollingDisabled={scrollingDisabled} intl={intl} />;
  } else if (!currentListing.id) {
    // Still loading the listing
    return <LoadingPage topbar={topbar} scrollingDisabled={scrollingDisabled} intl={intl} />;
  }

  // SEO canonical: the old listing URLs (/l/:slug/:id and the slug-less
  // /l/:id) redirect to the breadcrumb URL, so the keyword segments are
  // preserved and search engines move the ranking over. We know we are on an
  // old URL when there is no :category param. Redirect only once the listing
  // is loaded — before that we do not know its make and model — and never for
  // the pending-approval / draft variants, which have their own handling above
  // and are not indexed anyway.
  const isBreadcrumbUrl = !!rawParams.category;
  const isNormalVariant = !isPendingApprovalVariant && !isDraftVariant;
  if (!isBreadcrumbUrl && isNormalVariant && publicListingLink.name === 'ListingPage') {
    return <NamedRedirect {...publicListingLink} search={location.search} />;
  }

  // Listings without a make/model cannot use the breadcrumb URL, but the
  // slug-less /l/:id form still redirects to the slugged /l/:slug/:id one.
  const isSlugLessUrl = !rawParams.slug;
  if (isSlugLessUrl && isNormalVariant && listingSlug) {
    return <NamedRedirect name="ListingPageLegacy" params={params} search={location.search} />;
  }

  const {
    description = '',
    price = null,
    title: rawTitle = 'Wheelplace',
    publicData = {},
    metadata = {},
  } = currentListing.attributes;
  /* 18"" → 18" everywhere the page names the listing: the heading, the SEO
   * title, the structured data and the breadcrumb (P25009-486 BR-4). */
  const title = cleanListingTitle(rawTitle) || 'Wheelplace';

  const richTitle = (
    <span>
      {richText(title, {
        longWordMinLength: MIN_LENGTH_FOR_LONG_WORDS_IN_TITLE,
        longWordClass: css.longWord,
      })}
    </span>
  );

  const authorAvailable = currentListing && currentListing.author;
  const userAndListingAuthorAvailable = !!(currentUser && authorAvailable);
  const isOwnListing =
    userAndListingAuthorAvailable && currentListing.author.id.uuid === currentUser.id.uuid;

  /* P25009-454 BR-1/BR-2 — "Ta bort annons" only soft-deletes: the listing
   * stays Sharetribe `published`, so its direct URL still served a fully
   * buyable page and Google kept indexing it. To anyone but the owner a
   * deleted listing is a real 404 (staticContext makes the server answer
   * HTTP 404 too). The owner keeps the page — the action bar shows its
   * "Raderad annons" state — but marked noindex below. */
  const isListingDeleted = publicData.isDeleted === true;
  /* P25009-410 — a catalogue row is reachable from its seller's profile but is
   * not on the marketplace, and thin catalogue pages are what the catalogue
   * keeps out of the index. */
  const isCatalogueListing = publicData.visibility === 'catalog';
  /* P25009-485 BR-2 — a hidden trade-in is the workshop's own stock, "never
   * to customers": the same 404 for anyone but its owner, so a guessed or
   * shared link cannot show it, or sell it. */
  const isHiddenTradein = publicData.isTradein === true && publicData.isHide === true;
  if ((isListingDeleted || isHiddenTradein) && !isOwnListing) {
    if (isAuthenticated && !currentUser) {
      // Signed in but the user is still loading: deciding now would flash a
      // 404 at the owner on every hard refresh of their own deleted listing.
      return <LoadingPage topbar={topbar} scrollingDisabled={scrollingDisabled} intl={intl} />;
    }
    return <NotFoundPage staticContext={props.staticContext} />;
  }

  const { listingType, transactionProcessAlias, unitType, warehouse } = publicData;
  if (!(listingType && transactionProcessAlias && unitType)) {
    // Listing should always contain listingType, transactionProcessAlias and unitType)
    return (
      <ErrorPage topbar={topbar} scrollingDisabled={scrollingDisabled} intl={intl} invalidListing />
    );
  }
  const processName = resolveLatestProcessName(transactionProcessAlias.split('/')[0]);
  const isBooking = isBookingProcess(processName);
  const isPurchase = isPurchaseProcess(processName);

  // P25009-452 BR-1: only an explicit "no" flips the CTA — `null` (unknown /
  // endpoint hiccup) keeps the normal buy button. Own listings keep the
  // seller's own view untouched.
  const sellerCannotTakePayment =
    isPurchase && !isOwnListing && authorCanTakePayment === false;
  // P25009-476: the other payable state. The buyer orders as usual, but pays
  // through a link the seller sends, so the ad says so and makes no escrow
  // promise. Only an explicit "yes" from the server changes anything.
  const sellerUsesOwnPayment =
    isPurchase && !isOwnListing && !sellerCannotTakePayment && authorUsesOwnPayment === true;
  const processType = isBooking ? ('booking' ? isPurchase : 'purchase') : 'inquiry';

  const currentAuthor = authorAvailable ? currentListing.author : null;
  const ensuredAuthor = ensureUser(currentAuthor);
  const noPayoutDetailsSetWithOwnListing =
    isOwnListing && (processType !== 'inquiry' && !currentUser?.attributes?.stripeConnected);
  const payoutDetailsWarning = noPayoutDetailsSetWithOwnListing ? (
    <span className={css.payoutDetailsWarning}>
      <FormattedMessage id="ListingPage.payoutDetailsWarning" values={{ processType }} />
      <NamedLink name="StripePayoutPage">
        <FormattedMessage id="ListingPage.payoutDetailsWarningLink" />
      </NamedLink>
    </span>
  ) : null;

  // When user is banned or deleted the listing is also deleted.
  // Because listing can be never showed with banned or deleted user we don't have to provide
  // banned or deleted display names for the function
  const authorDisplayName = userDisplayNameAsString(ensuredAuthor, '');

  const { formattedPrice } = priceData(price, config.currency, intl);

  const commonParams = { params, history, routes: routeConfiguration };
  const onContactUser = handleContactUser({
    ...commonParams,
    currentUser,
    callSetInitialValues,
    location,
    setInitialValues,
    setInquiryModalOpen,
  });
  // Note: this is for inquiry state in booking and purchase processes. Inquiry process is handled through handleSubmit.
  const onSubmitInquiry = handleSubmitInquiry({
    ...commonParams,
    getListing,
    onSendInquiry,
    setInquiryModalOpen,
  });
  const onSubmit = handleSubmit({
    ...commonParams,
    currentUser,
    callSetInitialValues,
    getListing,
    onInitializeCardPaymentData,
  });

  const handleOrderSubmit = values => {
    const isCurrentlyClosed = currentListing.attributes.state === LISTING_STATE_CLOSED;
    if (isOwnListing || isCurrentlyClosed) {
      window.scrollTo(0, 0);
    } else {
      onSubmit(values);
    }
  };

  /* BR-13 — Köp nu used to open checkout with ONE item and no delivery
   * method, whatever the buyer had in mind. It now carries the stepper's
   * quantity and the chosen delivery (montering rides along as the add-on
   * checkout already prices), so checkout opens on the same order and the
   * same total. An inquiry keeps the old one-item request. */
  const handleBuyClick = orderData =>
    handleOrderSubmit({
      listingId: currentListing.id,
      deliveryMethod: 'none',
      quantity: 1,
      ...(isPurchase ? orderData : {}),
    });

  const facebookImages = listingImages(currentListing, 'facebook');
  const twitterImages = listingImages(currentListing, 'twitter');
  const schemaImages = listingProductImages(
    currentListing,
    `${config.layout.listingImage.variantPrefix}-2x`
  ).map(img => img.url);
  const marketplaceName = config.marketplaceName;
  const schemaTitle = intl.formatMessage(
    { id: 'ListingPage.schemaTitle' },
    { title, price: formattedPrice, marketplaceName }
  );
  // You could add reviews, sku, etc. into page schema
  // Read more about product schema
  // https://developers.google.com/search/docs/advanced/structured-data/product
  // const schemaPriceMaybe = price
  //   ? {
  //     price: intl.formatNumber(convertMoneyToNumber(price), {
  //       minimumFractionDigits: 2,
  //       maximumFractionDigits: 2,
  //     }),
  //     priceCurrency: price.currency,
  //   }
  //   : {};
  const schemaPriceMaybe = price
    ? {
      price: convertMoneyToNumber(price).toFixed(2),
      priceCurrency: price.currency,
    }
    : {};

  /* BR-12 — the hidden availability data must follow real stock. Note there is
   * no `|| 0` here: a private listing never tracks stock, and defaulting it to
   * zero told Google every private ad was out of stock. `stockAvailability`
   * treats "no stock tracking" as available, which is how the listing behaves. */
  const currentStock = currentListing.currentStock?.attributes?.quantity;
  const isListingClosed = currentListing.attributes.state === LISTING_STATE_CLOSED;
  const schemaAvailability = isListingClosed
    ? 'https://schema.org/SoldOut'
    : stockAvailability(currentStock);

  /* --- The generated answer sentence (P25009-409 BR-2) ---
   * Everything the sentence is allowed to claim, resolved here so the component
   * itself stays a pure render. Anything we cannot vouch for is left undefined
   * and simply does not appear in the sentence. */
  const sellerServices = ensuredAuthor.attributes?.profile?.publicData?.services;
  /* Only a montering service the seller actually has running. "Montering kan
   * läggas till i kassan" is a promise a buyer acts on, so a paused service or
   * a seller with none must not produce it. */
  const monteringService = servicesForListing(sellerServices, publicData).find(
    service => service.templateKey === MONTERING_TEMPLATE_KEY
  );
  /* P25009-484 BR-3 — only where montering is set to show for this kind of
   * product: a tyre buyer is not promised montering checkout won't offer. */
  const monteringOffered = !!monteringService;
  const { salesUnit: listingSalesUnit, setSize: listingSetSize } = resolveSalesUnit(publicData);
  const unitNoun = getUnitNoun(publicData);
  /* What the price buys, in the same words the order panel uses. A set price
   * read as a per-item price is the single most expensive misunderstanding on
   * this marketplace, so the sentence says which one it is.
   * P25009-498 — unused while the sentence is hidden; kept for when it returns. */
  // eslint-disable-next-line no-unused-vars
  const priceCovers =
    listingSalesUnit === SALES_UNIT_SET
      ? `hela satsen (${listingSetSize} ${unitNoun.many})`
      : `ett ${unitNoun.one}`;
  const listingCity = listingTown(publicData) || '';

  const handleViewPDF = async () => {
    /* The PDF engine and the document template together are roughly 2 MB of
     * JavaScript. Nobody needs them to look at a listing, so they are fetched
     * on this click instead of with the page. P25009-378 BR-1. */
    const [{ pdf }, { default: PDFDocument }] = await Promise.all([
      import('@react-pdf/renderer'),
      import('../../components/PDFDocument/PDFDocument'),
    ]);

    const blob = await pdf(
      <PDFDocument
        listing={currentListing}
        price={customFormatMoney(intl, price)}
        categories={config.categoryConfiguration.categories}
        listingFieldConfigs={listingConfig.listingFields}
        intl={intl}
        metadata={metadata}
      />
    ).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url);
  };

  const currentUrl = typeof window !== "undefined" && window.location.href;


  // const warehouses = currentListing?.author?.attributes?.profile?.publicData?.warehouses;
  /* P25009-484 BR-4 — the place a buyer collects from: the listing's own
   * address, else the seller's facility for it. */
  const listingAddress = pickupPlaceLine(
    pickupPlaceFor({ publicData: currentListing?.attributes?.publicData, facilities: listingWarehouses })
  );
  // const defaultWareHouse = Array.isArray(warehouses) ? warehouses.filter(w => w.isDefault) : [];
  // const address = defaultWareHouse[0]?.location?.selectedPlace?.address;
  // const email = defaultWareHouse[0]?.email;
  // const phoneNumber = defaultWareHouse[0]?.phoneNumber;
  // const whatsAppNumber = defaultWareHouse[0]?.whatsAppNumber;

  const listingWareHouse = Array.isArray(listingWarehouses)
    ? listingWarehouses.find(item => item.title === warehouse) || listingWarehouses.find(w => w.isDefault)
    : null;
  const address = listingWareHouse?.location?.selectedPlace?.address;
  const email = publicData.showEmail !== false ? listingWareHouse?.email : null;
  const phoneNumber = publicData.showPhone !== false ? listingWareHouse?.phoneNumber : null;
  const whatsAppNumber = listingWareHouse?.whatsAppNumber;

  const { numberOfBolts,
    boltCircle,
    diameter,
    tireWidthFront,
    profileFront,
    threaddepth = '',
    condition = '',
    hubHole = '',
    etFront } = publicData || {};

  const highlights = () => {

    const { listingFields } = config?.listing || {};

    const getDisplayValue = (field) => {
      const value = publicData[field]
      const listingField = listingFields.find(({ key }) => field === key) || {}
      const isEnum = listingField.schemaType == "enum" || listingField.schemaType == "multi-enum"

      if (isEnum) {
        const displayValue = listingField.enumOptions.find(({ option }) => option == value)?.label
        return displayValue || value
      } else {
        return value
      }
    }
    if (listingType === "wheel" || listingType === "business-wheel") {
      return (
        <div className={css.highlights}>
          {tireWidthFront && profileFront && diameter && `${getDisplayValue('tireWidthFront')}/${getDisplayValue("profileFront")}R${getDisplayValue("diameter")}`}
          {numberOfBolts && boltCircle && ` • ${getDisplayValue("numberOfBolts")}/${getDisplayValue("boltCircle")}`}
          {threaddepth && ` • ${getDisplayValue("threaddepth")}`}
          {condition && ` • ${getDisplayValue("condition")}`}
        </div>
      );
    } else if (listingType === "tire" || listingType === "businesstire") {
      return (
        <div className={css.highlights}>
          {tireWidthFront && profileFront && diameter && `${getDisplayValue("tireWidthFront")}/${getDisplayValue("profileFront")}R${getDisplayValue("diameter")}`}
          {threaddepth && ` • ${getDisplayValue("threaddepth")}`}
          {condition && ` • ${getDisplayValue("condition")}`}
        </div>
      );
    } else if (listingType === "rim" || listingType === "businesswheel") {
      return (
        <div className={css.highlights}>
          {numberOfBolts && boltCircle && `${getDisplayValue("numberOfBolts")}/${getDisplayValue("boltCircle")}`}
          {hubHole && ` • CB${getDisplayValue("hubHole")}`}
          {etFront && `ET${getDisplayValue("etFront")}`}
          {condition && ` • ${getDisplayValue("condition")}`}
        </div>
      );
    }
    return null;
  };

  const getSEOMetaProps = () => {
    const { listingFields } = config.listing;
    const getLabel = (field, value) => {
      const fieldConfig = listingFields.find(f => f.key === field);
      if (fieldConfig && fieldConfig.enumOptions) {
        const option = fieldConfig.enumOptions.find(o => o.option === value);
        return option ? option.label : value;
      }
      return value;
    };

    const conditionLabel = getLabel('condition', condition) || '';
    const tireTypeLabel = getLabel('tiretype', publicData.tiretype) || '';
    const carBrandLabel = getLabel('categoryLevel1', publicData.categoryLevel1) || '';
    const carModelLabel = getLabel('categoryLevel2', publicData.categoryLevel2) || '';
    const productLabel = getLabel('adType', publicData.adType) || '';
    const carbrand = carBrandLabel;
    const carmodel = carModelLabel;
    const tirecombination =
      tireWidthFront && profileFront && diameter
        ? `${tireWidthFront}/${profileFront}R${diameter}`
        : '';
    const city = listingTown(publicData) || '';
    const county = publicData.county || '';

    const seoTitle = `${title} | Wheelplace`;
    let seoDescription = '';

    if (listingType === 'wheel' || listingType === 'business-wheel') {
      seoDescription = `Köp ${productLabel} som passar ${carbrand} ${carmodel}, ${conditionLabel}. ${tireTypeLabel} i ${tirecombination} med Mönsterdjup ${threaddepth}. Finns i ${city}${county ? `, ${county}` : ''
        }. Kontakta ${authorDisplayName} för mer information och frågor.`;
    } else if (listingType === 'tire' || listingType === 'businesstire') {
      seoDescription = `Köp ${tireTypeLabel} i ${tirecombination}, ${conditionLabel} med Mönsterdjup ${threaddepth} mm. Finns i ${city}${county ? `, ${county}` : ''
        }. Kontakta ${authorDisplayName} för mer information och frågor.`;
    } else if (listingType === 'rim' || listingType === 'businesswheel') {
      // Console's key "1397" is 139.7 (P25009-488).
      const boltpattern =
        numberOfBolts && boltCircle ? `${numberOfBolts}/${boltCircleText(boltCircle) || boltCircle}` : '';
      seoDescription = `Köp fälgar i ${diameter} tum ${boltpattern}, ET ${etFront}, Navhål ${hubHole}, ${conditionLabel}. Finns i ${city}${county ? `, ${county}` : ''
        }. Kontakta ${authorDisplayName} för mer information och frågor.`;
    } else {
      seoDescription = description;
    }

    return { title: seoTitle, description: seoDescription };
  };

  const { title: seoTitle, description: seoDescription } = getSEOMetaProps();

  const getConfigLabel = (field, value) => {
    if (!value) return value;
    const fieldConfig = listingConfig.listingFields.find(f => f.key === field);
    return fieldConfig?.enumOptions?.find(o => o.option === value)?.label || value;
  };
  const categories = config.categoryConfiguration.categories;
  // A listing can carry a car brand that says nothing — an empty string, or
  // the literal "blank" the bulk-upload path writes when the seller left the
  // field out. Read those as absent, or the trail grows a level with no
  // meaning that links to a search page for a car that does not exist.
  // Lookup is case-insensitive because category ids are stored inconsistently
  // ("volvo" / "Volvo" / "VW"), which used to leave the raw id as the label.
  const makeValue = isUsableFacetValue(publicData.categoryLevel1)
    ? publicData.categoryLevel1
    : null;
  const makeCategory = findCategoryById(categories, makeValue);
  const modelValue =
    makeValue && isUsableFacetValue(publicData.categoryLevel2)
      ? publicData.categoryLevel2
      : null;
  const modelCategory = findCategoryById(makeCategory?.subcategories, modelValue);
  const breadcrumbListingType = getConfigLabel('adType', publicData.adType);
  const breadcrumbMake = makeCategory?.name || makeValue;
  const breadcrumbModel = modelCategory?.name || modelValue;

  // --- Product / Offer JSON-LD fields (rendered server-side via <Page>) ---
  // Clean canonical URL for the offer (breadcrumb path, no query/hash).
  const productCanonicalURL = `${config.marketplaceRootURL}${pathByRouteName(
    publicListingLink.name,
    routeConfiguration,
    publicListingLink.params
  )}`;
  // schema.org only has "New" and "Used"; map "new" to New and every other
  // grade (used / bega / begb / begc / usedlikenew) to Used.
  const schemaItemCondition = condition
    ? condition === 'new'
      ? 'https://schema.org/NewCondition'
      : 'https://schema.org/UsedCondition'
    : undefined;
  /* Product brand: the tyre or rim manufacturer, and nothing else. P25009-377
   * AC-1.
   *
   * This used to read `publicData.brand || breadcrumbMake`, and since about four
   * out of five listings store the enum's "other" placeholder, the fallback did
   * the work: Google was told a used wheel set was a "Volvo" product, which is
   * the car it fits, not who made it. A listing with no real manufacturer now
   * publishes no brand at all — brand is a recommended field, and no answer is
   * better than a wrong one. */
  const schemaBrandName = brandLabel(publicData.brand);
  /* P25009-409 BR-4 — the same rows the fit table shows, from the same
   * function. They used to be a second hand-written list here, which is how a
   * label drifts apart from the one on screen. Structured data that says
   * something the page does not is cloaking, so there is now one list. */
  const schemaAdditionalProperty = fitFactRows(publicData, { labelFor: getConfigLabel }).map(
    row => ({ '@type': 'PropertyValue', name: row.label, value: row.value })
  );

  /* --- BR-4: who is selling, from where, and on what terms --- */
  /* A dealer is a LocalBusiness. A private seller is a Person and gets no
   * address: this used to call everyone an Organization, which is wrong for an
   * individual and would attach a named person's town to their name. */
  const isBusinessSeller = isBusinessProfile(ensuredAuthor);
  const hasSellerPlace = !!(listingCity || publicData.county);
  const schemaPostalAddress = {
    '@type': 'PostalAddress',
    ...(listingCity ? { addressLocality: listingCity } : {}),
    ...(publicData.county ? { addressRegion: publicData.county } : {}),
    addressCountry: 'SE',
  };
  const schemaSeller = authorDisplayName
    ? {
        '@type': isBusinessSeller ? 'LocalBusiness' : 'Person',
        name: authorDisplayName,
        ...(isBusinessSeller && hasSellerPlace ? { address: schemaPostalAddress } : {}),
      }
    : null;
  // Where the wheels physically are. The town is on the page, so this states
  // nothing a reader cannot already see.
  const schemaAvailableAtOrFrom = hasSellerPlace
    ? {
        '@type': 'Place',
        ...(listingCity ? { name: listingCity } : {}),
        address: schemaPostalAddress,
      }
    : null;
  /* Shipping only when the seller switched it on AND named a price. Google
   * reads OfferShippingDetails as a commitment, and treating an absent price as
   * zero would advertise free delivery that nobody promised. */
  const shippingSubunits = publicData.shippingPriceInSubunitsOneItem;
  const schemaShippingDetails =
    publicData.shippingEnabled && shippingSubunits != null && price?.currency
      ? {
          '@type': 'OfferShippingDetails',
          shippingRate: {
            '@type': 'MonetaryAmount',
            value: (Number(shippingSubunits) / 100).toFixed(2),
            currency: price.currency,
          },
          shippingDestination: { '@type': 'DefinedRegion', addressCountry: 'SE' },
        }
      : null;
  /* Montering as a Service the buyer can add in checkout. Gated on exactly the
   * same condition as the visible sentence (monteringService above), so the
   * two can never disagree. */
  const schemaAddOns = monteringOffered
    ? [
        {
          '@type': 'Offer',
          name: 'Montering',
          ...(monteringService?.price != null && price?.currency
            ? {
                price: Number(monteringService.price).toFixed(2),
                priceCurrency: price.currency,
              }
            : {}),
          itemOffered: {
            '@type': 'Service',
            name: 'Montering och balansering',
            ...(schemaSeller ? { provider: schemaSeller } : {}),
          },
        },
      ]
    : [];
  /* The EAN, on the supplier-feed listings that carry one. `gtin13` is the
   * property for a 13-digit European article number; anything else goes in the
   * generic `gtin` rather than being asserted as a length it is not. */
  const eanDigits = String(publicData.ean || '').replace(/\D/g, '');
  const schemaGtinMaybe =
    eanDigits.length === 13 ? { gtin13: eanDigits } : eanDigits ? { gtin: eanDigits } : {};

  const productSchema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    description: seoDescription,
    /* The product's own name, not the page's. `seoTitle` ends in
     * " | Wheelplace", which belongs in the browser tab and in a search result
     * heading — but as a product name it tells Google the item is called
     * "Volvo XC60 | Wheelplace". P25009-377 AC-3. */
    name: title,
    image: schemaImages,
    sku: listingId.uuid,
    ...schemaGtinMaybe,
    ...(schemaItemCondition ? { itemCondition: schemaItemCondition } : {}),
    ...(schemaBrandName ? { brand: { '@type': 'Brand', name: schemaBrandName } } : {}),
    ...(schemaAdditionalProperty.length ? { additionalProperty: schemaAdditionalProperty } : {}),
    offers: {
      '@type': 'Offer',
      url: productCanonicalURL,
      ...schemaPriceMaybe,
      availability: schemaAvailability,
      ...(schemaItemCondition ? { itemCondition: schemaItemCondition } : {}),
      ...(schemaSeller ? { seller: schemaSeller } : {}),
      ...(schemaAvailableAtOrFrom ? { availableAtOrFrom: schemaAvailableAtOrFrom } : {}),
      ...(schemaShippingDetails ? { shippingDetails: schemaShippingDetails } : {}),
      ...(schemaAddOns.length ? { addOn: schemaAddOns } : {}),
    },
  };

  // --- Breadcrumb trail (clickable) + BreadcrumbList JSON-LD ---
  // Each crumb links to its indexable search page. The `url` field is used
  // only to build the JSON-LD; the Breadcrumbs component ignores it.
  const rootURL = config.marketplaceRootURL;
  const adTypeValue = isUsableFacetValue(publicData.adType) ? publicData.adType : null;
  const breadcrumbTrail = [
    { label: 'Hem', name: 'LandingPage', url: `${rootURL}/` },
    { label: 'Annonser', name: 'SearchPage', url: `${rootURL}/annonser` },
    ...(breadcrumbListingType && adTypeValue
      ? [
          {
            label: breadcrumbListingType,
            name: 'SearchPage',
            to: { search: `?pub_adType=${adTypeValue}` },
            url: `${rootURL}/annonser?pub_adType=${adTypeValue}`,
          },
        ]
      : []),
    ...(breadcrumbMake && makeValue
      ? [
          {
            label: breadcrumbMake,
            name: 'SearchPageMake',
            params: { make: makeValue },
            url: `${rootURL}/annonser/${makeValue}`,
          },
        ]
      : []),
    ...(breadcrumbModel && makeValue && modelValue
      ? [
          {
            label: breadcrumbModel,
            name: 'SearchPageMakeModel',
            params: { make: makeValue, model: modelValue },
            url: `${rootURL}/annonser/${makeValue}/${modelValue}`,
          },
        ]
      : []),
    { label: title || '' },
  ];
  // A ListItem without a name is an invalid breadcrumb to Google, and the last
  // crumb is the listing title, which can be empty. Drop nameless crumbs from
  // the JSON-LD; the visible trail above still renders them.
  const namedCrumbs = breadcrumbTrail.filter(crumb => {
    const name = typeof crumb.label === 'string' ? crumb.label : title;
    return !!name;
  });
  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: namedCrumbs.map((crumb, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: typeof crumb.label === 'string' ? crumb.label : title,
      // The last (current) crumb has no url, so it has no `item`.
      ...(crumb.url ? { item: crumb.url } : {}),
    })),
  };

  return (
    <Page
      title={seoTitle}
      scrollingDisabled={scrollingDisabled}
      author={authorDisplayName}
      description={seoDescription}
      facebookImages={facebookImages}
      twitterImages={twitterImages}
      schema={[productSchema, breadcrumbSchema]}
      // Only the owner ever gets this far with a deleted listing (P25009-454
      // BR-2) — their reference view must not stay in Google's index.
      noindex={isListingDeleted || isCatalogueListing}
    >
      <LayoutSingleColumn
        className={css.pageRoot}
        topbar={topbar}
        footer={<FooterContainer />}
      >
        <Breadcrumbs trail={breadcrumbTrail} singleLineOnMobile />
        {/* P25009-482 BR-9 — one DOM order that serves both layouts:
          *
          *   top      action bars + gallery
          *   buy box  title, fit check, price, delivery, total, Köp nu
          *   rest     everything a buyer reads after deciding
          *
          * On a phone that IS the reading order, so the buy card sits
          * directly under the gallery (it used to render ~2 000 px down,
          * after every other section). From --viewportLarge the wrapper is a
          * two-column grid: top and rest on the left, the buy box spanning
          * both rows on the right, sticky. */}
        <div className={css.contentWrapperForProductLayout}>
          <div className={css.mainColumnTop}>
            {currentListing.id && noPayoutDetailsSetWithOwnListing ? (
              <ActionBarMaybe
                className={css.actionBarForProductLayout}
                isOwnListing={isOwnListing}
                listing={currentListing}
                showNoPayoutDetailsSet={noPayoutDetailsSetWithOwnListing}
                onManageDisableScrolling={onManageDisableScrolling}
              />
            ) : null}
            {currentListing.id ? (
              <ActionBarMaybe
                className={css.actionBarForProductLayout}
                isOwnListing={isOwnListing}
                listing={currentListing}
                onManageDisableScrolling={onManageDisableScrolling}
                sessionURL={sessionURL}
                sessionId={sessionId}
                payListingBoostedPaymentSessionURL={payListingBoostedPaymentSessionURL}
                onPayListingBoostedPayment={onPayListingBoostedPayment}
                editParams={{
                  id: listingId.uuid,
                  slug: listingSlug,
                  type: listingPathParamType,
                  tab: listingTab,
                }}
              />
            ) : null}

            <SectionGallery
              listing={currentListing}
              variantPrefix={config.layout.listingImage.variantPrefix}
              currentUser={currentUser}
            />
          </div>

          <div className={css.orderColumnForProductLayout}>
            <WheelplaceInfoPanel
              listing={currentListing}
              intl={intl}
              listingFieldConfigs={listingConfig.listingFields}
              listingAddress={listingAddress}
              isOwnListing={isOwnListing}
              isLiked={liked}
              onToggleFavourite={toggleFavourite}
              onShare={() => {
                if (typeof navigator !== 'undefined' && navigator.share) {
                  navigator.share({ title, url: currentUrl }).catch(() => { });
                }
              }}
              onViewPDF={handleViewPDF}
              onBuyClick={handleBuyClick}
              onMessageClick={onContactUser}
              isInquiryProcess={!isBooking && !isPurchase}
              sellerCannotTakePayment={sellerCannotTakePayment}
              sellerUsesOwnPayment={sellerUsesOwnPayment}
              order={buyBoxOrder}
              buyLabelId={
                !isBooking && !isPurchase
                  ? 'InquiryForm.submitButtonText'
                  : 'OrderPanel.ctaButtonMessagePurchase'
              }
            />
          </div>

          <div className={css.mainColumnRest}>
            {/* P25009-498 — hidden for now, kept for later: uncomment this and
              * the import to bring it back.
              *
              * P25009-409 BR-2 / AC-1 — the quotable answer sentence, generated
              * from the listing's own facts and rendered without fetching
              * anything, so it is in the HTML the server delivers. Reading
              * order: title (buy box), then this, then the fit table.
            <SectionAnswerLeadMaybe
              publicData={publicData}
              priceLabel={formattedPrice}
              priceCovers={priceCovers}
              city={listingCity}
              sellerName={authorDisplayName}
              monteringOffered={monteringOffered}
              deliveryDays={publicData.deliveryDays}
              availability={isListingClosed ? 'sold_out' : 'in_stock'}
            />
            */}

            {/* Detaljer — the fit facts. P25009-443 BR-8: on a phone the
              * section header prints its value even when closed; Passform is
              * what the buyer came for, so it starts open. */}
            <MobileSection
              label="Passform"
              value={buildSpecLine(publicData, listingConfig.listingFields)}
              defaultOpen
            >
              <CustomListingFields
                publicData={publicData}
                metadata={metadata}
                listingFieldConfigs={listingConfig.listingFields}
                categoryConfiguration={config.categoryConfiguration}
                intl={intl}
              />
            </MobileSection>

            {/* BR-11 — the description, three lines until the buyer asks for
              * more. The full text stays in the delivered HTML. */}
            {description ? (
              <div className={css.descriptionContainer}>
                <h2 className={css.detailsTitle}>Beskrivning</h2>
                <SectionDescriptionClamp text={description} />
              </div>
            ) : null}

            {/* P25009-407 AC-3 — the dealer's other packages for this car.
              * Renders nothing unless there is something to switch to. */}
            <SectionPackageVariantsMaybe
              listingId={currentListing.id?.uuid}
              publicData={publicData}
              currentPrice={
                currentListing.attributes?.price?.amount
                  ? currentListing.attributes.price.amount / 100
                  : null
              }
            />
            {/* P25009-406 AC-2 — the way through to this dealer's full range. */}
            <SectionFullRangeCtaMaybe
              publicData={publicData}
              authorId={currentAuthor?.id?.uuid}
              authorDisplayName={authorDisplayName}
            />

            {/* P25009-498 — "Passar även" hidden for now, kept for later:
              * uncomment this, the import and the fetch in ListingPage.duck.js
              * loadData to bring it back.
              *
              * P25009-398 AC-2 — every car these wheels fit, worked out from
              * the listing's own facts (loaded in loadData, so it is in the
              * server-delivered HTML).
            <SectionFitsAlsoMaybe
              listingId={currentListing?.id?.uuid}
              listingPublicData={publicData}
            />
            */}

            {/* P25009-486 BR-5 — "Visa hjulen på din bil" sits directly above
              * the seller card, on desktop and phone alike (one DOM order).
              * Behaviour unchanged. Never between the price and Köp nu: that
              * is the buy box, a separate column / card. */}
            <ViewWheelsOnCar listing={currentListing} />

            {/* BR-8 (443): seller info is depth — closed by default on a phone,
              * the name in the header. The inquiry modal inside renders through
              * a portal, so contacting works whatever the collapse state.
              * P25009-482 BR-7: no e-mail or phone reveal on the listing page
              * (the seller's profile page keeps them). */}
            <MobileSection label="Säljaren" value={authorDisplayName}>
              <SectionAuthorMaybe
                title={title}
                listing={currentListing}
                authorDisplayName={authorDisplayName}
                onContactUser={onContactUser}
                isInquiryModalOpen={isAuthenticated && inquiryModalOpen}
                onCloseInquiryModal={() => setInquiryModalOpen(false)}
                sendInquiryError={sendInquiryError}
                sendInquiryInProgress={sendInquiryInProgress}
                onSubmitInquiry={onSubmitInquiry}
                currentUser={currentUser}
                onManageDisableScrolling={onManageDisableScrolling}
                whatsAppNumber={whatsAppNumber}
              />
              {/* P25009-486 BR-6 — the seller's Google rating and review count
                * (the profile page's badge; nothing shows without an
                * operator-set Google place). */}
              <GoogleReviewsBadge profileUserId={currentListing?.author?.id?.uuid} />
            </MobileSection>

            {/* BR-11 — "Andra {vinterhjul} till din {modell}"; the seller row is
              * gone. */}
            <SectionRecommendedListings
              listing={currentListing}
              carModel={
                plateInfoModelName(buyerCarPlate) ||
                breadcrumbModel ||
                ''
              }
            />

            <SectionReviews
              reviews={reviews}
              fetchReviewsError={fetchReviewsError}
              publicData={publicData}
            />

            {/* BR-9 — on a phone the message link closes the page; the buy
              * card keeps the one buying action and the sticky bar has the
              * chat icon. */}
            {isPurchase && !isOwnListing && !sellerCannotTakePayment && publicData.allowMessages !== false ? (
              <button
                type="button"
                className={css.mobileMessageLink}
                onClick={() => {
                  trackListingEvent('message_seller', {
                    listing_id: currentListing.id?.uuid,
                    surface: 'page_end',
                  });
                  onContactUser();
                }}
              >
                Frågor om hjulen? Skicka meddelande till {authorDisplayName || 'säljaren'}
              </button>
            ) : null}
          </div>
        </div>
        <MobileStickyCTA
          listing={currentListing}
          intl={intl}
          isOwnListing={isOwnListing}
          isInquiryProcess={!isBooking && !isPurchase}
          sellerCannotTakePayment={sellerCannotTakePayment}
          order={buyBoxOrder}
          onBuyClick={handleBuyClick}
          onMessageClick={onContactUser}
          buyLabelId={
            !isBooking && !isPurchase
              ? 'InquiryForm.submitButtonText'
              : 'OrderPanel.ctaButtonMessagePurchase'
          }
        />
      </LayoutSingleColumn>
    </Page>
  );
};

ListingPageComponent.defaultProps = {
  currentUser: null,
  inquiryModalOpenForListingId: null,
  showListingError: null,
  reviews: [],
  fetchReviewsError: null,
  monthlyTimeSlots: null,
  sendInquiryError: null,
  lineItems: null,
  fetchLineItemsError: null,
};

ListingPageComponent.propTypes = {
  // from useHistory
  history: shape({
    push: func.isRequired,
  }).isRequired,
  // from useLocation
  location: shape({
    search: string,
  }).isRequired,

  // from useIntl
  intl: intlShape.isRequired,

  // from useConfiguration
  config: object.isRequired,
  // from useRouteConfiguration
  routeConfiguration: arrayOf(propTypes.route).isRequired,

  params: shape({
    id: string.isRequired,
    slug: string,
    variant: oneOf([LISTING_PAGE_DRAFT_VARIANT, LISTING_PAGE_PENDING_APPROVAL_VARIANT]),
  }).isRequired,

  isAuthenticated: bool.isRequired,
  currentUser: propTypes.currentUser,
  getListing: func.isRequired,
  getOwnListing: func.isRequired,
  onManageDisableScrolling: func.isRequired,
  scrollingDisabled: bool.isRequired,
  inquiryModalOpenForListingId: string,
  showListingError: propTypes.error,
  callSetInitialValues: func.isRequired,
  reviews: arrayOf(propTypes.review),
  fetchReviewsError: propTypes.error,
  monthlyTimeSlots: object,
  // monthlyTimeSlots could be something like:
  // monthlyTimeSlots: {
  //   '2019-11': {
  //     timeSlots: [],
  //     fetchTimeSlotsInProgress: false,
  //     fetchTimeSlotsError: null,
  //   }
  // }
  sendInquiryInProgress: bool.isRequired,
  sendInquiryError: propTypes.error,
  onSendInquiry: func.isRequired,
  onInitializeCardPaymentData: func.isRequired,
  onFetchTransactionLineItems: func.isRequired,
  lineItems: array,
  fetchLineItemsInProgress: bool.isRequired,
  fetchLineItemsError: propTypes.error,
};

const EnhancedListingPage = props => {
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();

  return (
    <ListingPageComponent
      config={config}
      routeConfiguration={routeConfiguration}
      intl={intl}
      history={history}
      location={location}
      {...props}
    />
  );
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.auth;
  const { sessionURL,
    payListingBoostedPaymentSessionURL,
  } = state.ManageListingsPage;
  const {
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    sendInquiryInProgress,
    sendInquiryError,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    inquiryModalOpenForListingId,
    savedQueries,
  } = state.ListingPage;
  const { currentUser } = state.user;

  const getListing = id => {
    const ref = { id, type: 'listing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  const getOwnListing = id => {
    const ref = { id, type: 'ownListing' };
    const listings = getMarketplaceEntities(state, [ref]);
    return listings.length === 1 ? listings[0] : null;
  };

  return {
    isAuthenticated,
    currentUser,
    getListing,
    getOwnListing,
    scrollingDisabled: isScrollingDisabled(state),
    inquiryModalOpenForListingId,
    showListingError,
    reviews,
    fetchReviewsError,
    monthlyTimeSlots,
    lineItems,
    fetchLineItemsInProgress,
    fetchLineItemsError,
    sendInquiryInProgress,
    sendInquiryError,
    savedQueries,
    sessionURL,
    payListingBoostedPaymentSessionURL,
  };
};

const mapDispatchToProps = dispatch => ({
  onManageDisableScrolling: (componentId, disableScrolling) =>
    dispatch(manageDisableScrolling(componentId, disableScrolling)),
  callSetInitialValues: (setInitialValues, values, saveToSessionStorage) =>
    dispatch(setInitialValues(values, saveToSessionStorage)),
  onFetchTransactionLineItems: params => dispatch(fetchTransactionLineItems(params)),
  onSendInquiry: (listing, message) => dispatch(sendInquiry(listing, message)),
  onInitializeCardPaymentData: () => dispatch(initializeCardPaymentData()),
  onFetchTimeSlots: (listingId, start, end, timeZone) =>
    dispatch(fetchTimeSlots(listingId, start, end, timeZone)),
  onPayListingBoostedPayment: params => dispatch(payListingBoostedPayment(params))
});

// Note: it is important that the withRouter HOC is **outside** the
// connect HOC, otherwise React Router won't rerender any Route
// components since connect implements a shouldComponentUpdate
// lifecycle hook.
//
// See: https://github.com/ReactTraining/react-router/issues/4671
const ListingPage = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(EnhancedListingPage);

export default ListingPage;
